module.exports = __webpack_public_path__ + "static/media/fly0159.41121033.webp";